<script lang="ts" setup>
// Une ligne de notification non lue (markup DS `gd-notif-item`, port de chrome/Topbar.jsx).
// Extrait en composant dédié car `useTranslatedTimeAgo` (composable) ne peut pas être appelé
// dans un v-for : chaque ligne calcule son propre horodatage relatif.
import useTranslatedTimeAgo from '~/composables/useTranslatedTimeAgo';
import type { UnreadNotification } from '~/interfaces/notifications/main';

const props = defineProps<{ notification: UnreadNotification }>();
const emit = defineEmits<{ read: [notification: UnreadNotification] }>();

const when = useTranslatedTimeAgo(() => props.notification.createdAt);
</script>

<template>
  <div class="gd-notif-item">
    <div class="gd-notif-main">
      <div class="gd-notif-title">
        {{ notification.title }}
      </div>
      <div class="gd-notif-body">
        {{ notification.content }}
      </div>
      <div class="gd-notif-when">
        {{ when }}
      </div>
    </div>
    <button
      type="button"
      class="gd-notif-read"
      title="Marquer comme lue"
      @click="emit('read', notification)"
    >
      <DsIcon
        name="check"
        :size="13"
        color="var(--text-3)"
      />
    </button>
  </div>
</template>
